import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { longDateString } from "../../utils";
import "react-big-calendar/lib/css/react-big-calendar.css";

import {
    getJobSchedules,
    getJobSchedule,
    saveJobSchedule,
    deleteJobSchedule,
} from "../../services/RepositoryService";
import StarekContext from "../../context/StarekContext";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { confirm } from "../../components/Confirmation";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import moment from "moment-timezone";

import { Calendar, momentLocalizer } from "react-big-calendar";

const localizer = momentLocalizer(moment);

const JobSchedule2 = () => {
    const context = useContext(StarekContext);
    const navigator = useNavigate();
    const [items, setItems] = useState();
    const [loadingPrimary, setLoadingPrimary] = useState(true);

    useEffect(() => {
        (async () => {
            try {
                const includes = ["part", "created_by", "updated_by"];
                const jobSchedules = await getJobSchedules(
                    context.activePlant.id,
                    includes
                );
                setItems(jobSchedules);
                console.log("jobSchedules=>", jobSchedules);
            } catch (error) {
                context.showErrorMessage(error.message);
            }
            setLoadingPrimary(false);
        })();
    }, []);

    return loadingPrimary ? (
        <>
            <Spinner />
            <div className="text-xs d-flex justify-content-center">
                <i className="fa fa-industry fa-10x"></i>
            </div>
        </>
    ) : (
        <section className="content">
            <Calendar
                localizer={localizer}
                events={items.map((item) => {
                    return {
                        start: moment(item.start_time).toDate(),
                        end: moment(item.end_time).toDate(),
                        title: item.name,
                    };
                })}
                startAccessor="start"
                endAccessor="end"
                style={{ height: 500 }}
            />
        </section>
    );
};

export { JobSchedule2 };
